import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AumicoIntegrationsConfig, AumicoIntegrationsConfigService } from '../aumico-integrations.config';
import {
    ICreatePartnerClientBody,
    IPartnerClient,
    IPartnerClientWithSecret,
} from '../models/outbound/partner-client.model';

@Injectable()
export class PartnerClientService {
    private readonly endpoint: string;

    public constructor(
        private readonly http: HttpClient,
        @Inject(AumicoIntegrationsConfigService) config: AumicoIntegrationsConfig,
    ) {
        this.endpoint = `${config.apiGateway}partner-clients`;
    }

    public list(): Observable<IPartnerClient[]> {
        return this.http.get<IPartnerClient[]>(this.endpoint);
    }

    public create(body: ICreatePartnerClientBody): Observable<IPartnerClientWithSecret> {
        return this.http.post<IPartnerClientWithSecret>(this.endpoint, body);
    }

    public rotateSecret(id: string): Observable<IPartnerClientWithSecret> {
        return this.http.post<IPartnerClientWithSecret>(`${this.endpoint}/${id}/rotate-secret`, {});
    }

    public revoke(id: string): Observable<void> {
        return this.http.delete<void>(`${this.endpoint}/${id}`);
    }
}
